import axios from "axios";

class AuthService {
    login(username, password, clientid, errorCallback) {
        return axios.post(window.config.API_URL + "login", { username, password, clientid }).then(
            (response) => {
                localStorage.setItem("reduxState",
                    JSON.stringify({
                        "auth": { "username": response.data.username, "token": response.data.token, "refresh": response.data.refresh },
                        "header": { "isOpen": false }
                    }));
                return true;
            },
            (error) => {
                errorCallback(error);
                localStorage.removeItem("reduxState");
                return false;
            }
        );
    }

    refresh() {
        let me = JSON.parse(localStorage.getItem("reduxState"));

        let headers_config = {
            headers: {
                'Authorization': 'Bearer ' + me.auth.refresh
            }
        }

        return axios.post(window.config.API_URL + "refresh", {}, headers_config).then(
            (response) => {
                localStorage.setItem("reduxState",
                    JSON.stringify({
                        "auth": { "username": response.data.username, "token": response.data.token, "refresh": response.data.refresh },
                        "header": { "isOpen": false }
                    }));
            },
            (error) => {
                localStorage.removeItem("reduxState");
                window.location = "/login";
            }
        );
    }
}

export default new AuthService();
